import React,{useState,useEffect} from "react";
import "../assets/css/calculator.css";
import { Chart } from "react-google-charts";

const Calculator = () => {
  const [Amount, setAmount] = useState(500000);
  const [Length, setLength] = useState(5);
  const [Interest, setInterest] = useState(10);
  const [Monthly, setMonthly] = useState(10624)
  const [TotalInterest, setTotalInterest] = useState(137440)
  const [paybale, setpaybale] = useState(1274880)
 
      const calculate=()=>{
     
    const p = parseFloat(Amount);
    const r = parseFloat(Interest) / 1200; // monthly interest rate
    const n = parseFloat(Length) * 12; // total number of months
    const e =Math.round((p * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1)); // EMI formula
    const TotalInterest=((e*12)*Length)

    setAmount(p)
    setMonthly(e);
    setTotalInterest( TotalInterest-p)
    setpaybale(TotalInterest)

    console.log(Amount);
 
      }

      let data = [
        ["Task", "Hours per Day"],
        ["Amount",Amount],
        ["TotalInterest", TotalInterest]
      ];
      
      const options = {
        title: "Loan AND Interest",
        pieHole: 0.4,
        is3D: false,
      };
      
     

  return (
    <>
      <div className="h-[10%]">
     
        <h1 className=" text-violet-800  text-center text-[35px] mt-2">
          Car EMI Calculator
        </h1>
      </div>

      <div className="h-[90%] sm:w-[60%] w-[90%] flex justify-center  flex-col items-center  rounded-lg text-[17px] font-semibold  shadow-2xl mb-5">
      <div className="h-[70%]  w-[100%] flex justify-center sm:flex-row flex-col items-center  rounded-lg">
        <div className="input h-[100%] sm:w-[50%] w-[100%] flex flex-col justify-between items-center ">
          <div className="Amount w-[100%] h-[25%] flex flex-col justify-between items-center   ">
            <div className="cal  h-[50%] w-[100%] flex justify-evenly items-center  ">
                <div className="">Amount</div>
                <div className="text-violet-600">{Amount}₹</div>
            </div>
            <div className="range h-[50%] w-[100%] flex justify-evenly items-center">
            {/* <input class="rounded-lg overflow-hidden appearance-none bg-black h-5 w-[90%]" type="range" min="1" max="100" step="1" value="15" /> */}
            <input id="customRange1" class="form-range  h-5 w-[90%] "type="range" min="100000" max="10000000" step="100000" value={Amount} onChange={(e)=>setAmount(e.target.value)}/>
            </div>
          </div>
          <div className="Amount w-[100%] h-[25%] flex flex-col justify-center items-center   ">
            <div className="cal  h-[50%] w-[100%] flex justify-evenly items-center  ">
                <div className="">Year</div>
                <div className="text-violet-600">{Length}/Year</div>
            </div>
            <div className="range h-[50%] w-[100%] flex justify-evenly items-center ">
            {/* <input class="rounded-lg overflow-hidden appearance-none bg-black h-5 w-[90%]" type="range" min="1" max="100" step="1" value="15" /> */}
            <input id="customRange1" class="form-range  h-5 w-[90%] "type="range" min="1" max="20" step="1" value={Length} onChange={(e)=>setLength(e.target.value)}/>
            </div>
          </div>
          <div className="Amount w-[100%] h-[25%] flex flex-col justify-center items-center  ">
            <div className="cal  h-[50%] w-[100%] flex justify-evenly items-center  ">
                <div className="">% Interest</div>
                <div className="text-violet-600">{Interest}₹/Yearly</div>
            </div>
            <div className="range h-[50%] w-[100%] flex justify-evenly items-center ">
            {/* <input class="rounded-lg overflow-hidden appearance-none bg-black h-5 w-[90%]" type="range" min="1" max="100" step="1" value="15" /> */}
            <input id="customRange1" class="form-range  h-5 w-[90%] "type="range" min="1" max="15" step="1" value={Interest} onChange={(e)=>setInterest(e.target.value)}/>
            </div>
          </div>
          <div className="Amount w-[100%] h-[25%] flex flex-col justify-center items-center   ">
            <div className="cal  h-[100%] w-[100%] flex justify-evenly items-center  ">
        
            <button className=" bg-red-500 shadow-lg  shadow-red-600 text-white text-[25px] px-5 rounded-full" onClick={calculate}>Calculate</button>
        
            </div>
          
          </div>
        
          
        </div>
        <div  className="piechart h-[100%] sm:w-[50%] w-[100%] flex justify-center items-center sm:mt-0 mt-5"> 
        <Chart
      chartType="PieChart"
      width="100%"
      height="100%"
      data={data}
      options={options}
    
    />
        </div>
        </div>
        <div className="res h-[30%] w-[100%] flex flex-col justify-center items-center rounded-lg">
            <div className="momth h-[20%]  p-3 text-center text-2xl ">
            <div className="">Monthly Payble</div>
            <div className=" bg-green-500 shadow-lg  shadow-green-600 text-white text-[25px] px-5 py-2 rounded-full">{Monthly} ₹ /monthly</div>
            </div>
            <div className="h-[80%] w-[100%] flex flex-col sm:flex-row  justify-evenly items-center">
            <div className="momth h-[20%] p-3 text-center ">
            <div className="">Principal</div>
            <div className="text-violet-600">{Amount}₹</div>
            </div>

            <div className="momth h-[20%]  p-3 text-center">
            <div className="">Toatal Interest</div>
            <div className="text-violet-600">{TotalInterest}₹</div>
            </div>

            <div className="momth h-[20%]  p-3 text-center ">
            <div className="">Total Payable</div>
            <div className="text-violet-600">{paybale}₹</div>
            </div>


            </div>
        </div>
      </div>
    </>
  );
};

export default Calculator;
